module.exports = require("@wildboar/scrypt-0");